<p>first works!</p>
<button (click)="onClick()">Click me</button>